/** Vendors */
import axios from "axios";

const {
  VITE_REACT_APP_API_ENDPOINT,
  VITE_REACT_APP_AUTH0_DOMAIN,
  VITE_REACT_APP_BU_APP_RESOURCE_NAME,
  VITE_REACT_APP_BU_CLIENT_RESOURCE_NAME,
} = import.meta.env;

/** Types */
const app = VITE_REACT_APP_BU_APP_RESOURCE_NAME;
const client = VITE_REACT_APP_BU_CLIENT_RESOURCE_NAME;

/** Set Axios Defaults */
axios.defaults.baseURL = VITE_REACT_APP_API_ENDPOINT;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["x-bu-app"] = app;
axios.defaults.headers.common["x-bu-client"] = client;

axios.interceptors.response.use(
  function (response) {
    if (!response.hasOwnProperty("data")) return response;
    return response.data;
  },
  function (error) {
    console.log(error);
    if (
      error.message &&
      (error.response.message === "The incoming token has expired" ||
        error.response.data.message === "The incoming token has expired")
    ) {
      location.reload();
    }

    return Promise.reject({
      response: error.response.message.data.message,
      description: error.response.message.data.error_description,
    });
  }
);

axios.interceptors.response.use(
  function (response) {
    if (!Object.prototype.hasOwnProperty.call(response, "data")) {
      return response;
    }
    return response.data;
  },
  function (error) {
    console.log("Error Message: ", error?.message);
    return Promise.reject({ error: error.message });
  }
);

export function createCleanedInstance() {
  const instance = axios.create({
    baseURL: String(VITE_REACT_APP_AUTH0_DOMAIN),
    timeout: 10000,
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });

  /** Step 2a. Reset Auth0 Headers */
  instance.defaults.headers.common["Authorization"] = null;
  instance.defaults.headers.common["x-bu-app"] = null;
  instance.defaults.headers.common["x-bu-client"] = null;

  return instance;
}
